const en = {
  translation: {
    button_join_room: "Join Room",
    button_create_room: "Create Room",
    button_ready: "Ready",
    button_cancel: "Cancel",
    button_start: "Start",
    button_deal: "DEAL",
    button_set: "SET !",
    button_play_again: "Play again",
    label_buzz: "BUZZ",
    label_start: "START",
    label_deal: "DEAL",
    cards_left: "Cards Left",
    placeholder_username: "Username",
    lobby_header: "Waiting for other players",
    lobby_text:
      "Invite your friends to join the room by sending them the link over.",
    score_board_header: "Players",

    game_over: "GAME OVER",

    rules_main_header: "RULES",
  },
};

export default en;
